var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('navigation'),_c('app-header'),_c('v-main',[(!_vm.isLoading)?_c('v-container',{attrs:{"fluid":""}},[_c('router-view')],1):_vm._e()],1),_c('app-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }